import { Col, Collection, CollectionItem, Row } from "react-materialize";

import foto1 from "../../Assets/Goloborodova.jpg";
import foto2 from "../../Assets/Budyakova.jpg";
import foto3 from "../../Assets/Ilina.jpg";
import styles from "./Contributed.module.scss";

export const Contributed = () => {
  return (
    <>
      <div className="center-align blue-grey darken-3">
        <h5 className={styles.contributed__header}>Разработано при участии</h5>
      </div>
      <Row className="container">
        <Col m={12} s={12} className={styles.contributed__img}>
          <Collection className="container">
            <CollectionItem className="avatar">
              <img alt="Goloborodova" className="circle" src={foto1} />
              <span className="title">
                <b>Виктория Голобородова</b>
              </span>
              <p>
                Клинический психолог, к.п.н., доцент, супервизор, онкопсихолог,
                военный психолог.
              </p>
              <p>
                Генеральный директор АНО ДПО «Международный центр
                «Профессионал», соавтор и учредитель АНО "Благотворительный
                центр психологической поддержки тяжелобольных пациентов и их
                родственников ОПОРА".
              </p>
              <p>
                Почётный член Международной Профессиональной Ассоциации
                Психологов ( МПАП), супервизор Ассоциации Профессиональных
                Психологов и Психотерапевтов.
              </p>
              <a
                className="secondary-content"
                href="https://vk.com/box107"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  id="mdi-vk"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0077FF"
                >
                  <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93V15.07C2 20.67 3.33 22 8.93 22H15.07C20.67 22 22 20.67 22 15.07V8.93C22 3.33 20.67 2 15.07 2M18.15 16.27H16.69C16.14 16.27 15.97 15.82 15 14.83C14.12 14 13.74 13.88 13.53 13.88C13.24 13.88 13.15 13.96 13.15 14.38V15.69C13.15 16.04 13.04 16.26 12.11 16.26C10.57 16.26 8.86 15.32 7.66 13.59C5.85 11.05 5.36 9.13 5.36 8.75C5.36 8.54 5.43 8.34 5.85 8.34H7.32C7.69 8.34 7.83 8.5 7.97 8.9C8.69 11 9.89 12.8 10.38 12.8C10.57 12.8 10.65 12.71 10.65 12.25V10.1C10.6 9.12 10.07 9.03 10.07 8.68C10.07 8.5 10.21 8.34 10.44 8.34H12.73C13.04 8.34 13.15 8.5 13.15 8.88V11.77C13.15 12.08 13.28 12.19 13.38 12.19C13.56 12.19 13.72 12.08 14.05 11.74C15.1 10.57 15.85 8.76 15.85 8.76C15.95 8.55 16.11 8.35 16.5 8.35H17.93C18.37 8.35 18.47 8.58 18.37 8.89C18.19 9.74 16.41 12.25 16.43 12.25C16.27 12.5 16.21 12.61 16.43 12.9C16.58 13.11 17.09 13.55 17.43 13.94C18.05 14.65 18.53 15.24 18.66 15.65C18.77 16.06 18.57 16.27 18.15 16.27Z" />
                </svg>
              </a>
            </CollectionItem>
            <CollectionItem className="avatar">
              <img alt="Budyakova" className="circle" src={foto2} />
              <span className="title">
                <b>Мария Будякова</b>
              </span>
              <p>
                Автор трансформационных игр и метафорических ассоциативных карт.
              </p>
              <p>Cоздатель школы игропрактики "Игры жизни".</p>
              <p>Организатор фестиваля игропрактики "Море игр" в г. Ялта.</p>
              <a
                className="secondary-content"
                href="https://vk.com/happyjiva"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  id="mdi-vk"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0077FF"
                >
                  <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93V15.07C2 20.67 3.33 22 8.93 22H15.07C20.67 22 22 20.67 22 15.07V8.93C22 3.33 20.67 2 15.07 2M18.15 16.27H16.69C16.14 16.27 15.97 15.82 15 14.83C14.12 14 13.74 13.88 13.53 13.88C13.24 13.88 13.15 13.96 13.15 14.38V15.69C13.15 16.04 13.04 16.26 12.11 16.26C10.57 16.26 8.86 15.32 7.66 13.59C5.85 11.05 5.36 9.13 5.36 8.75C5.36 8.54 5.43 8.34 5.85 8.34H7.32C7.69 8.34 7.83 8.5 7.97 8.9C8.69 11 9.89 12.8 10.38 12.8C10.57 12.8 10.65 12.71 10.65 12.25V10.1C10.6 9.12 10.07 9.03 10.07 8.68C10.07 8.5 10.21 8.34 10.44 8.34H12.73C13.04 8.34 13.15 8.5 13.15 8.88V11.77C13.15 12.08 13.28 12.19 13.38 12.19C13.56 12.19 13.72 12.08 14.05 11.74C15.1 10.57 15.85 8.76 15.85 8.76C15.95 8.55 16.11 8.35 16.5 8.35H17.93C18.37 8.35 18.47 8.58 18.37 8.89C18.19 9.74 16.41 12.25 16.43 12.25C16.27 12.5 16.21 12.61 16.43 12.9C16.58 13.11 17.09 13.55 17.43 13.94C18.05 14.65 18.53 15.24 18.66 15.65C18.77 16.06 18.57 16.27 18.15 16.27Z" />
                </svg>
              </a>
            </CollectionItem>
            <CollectionItem className="avatar">
              <img alt="Ilina" className="circle" src={foto3} />
              <span className="title">
                <b>Ирина Ильина</b>
              </span>
              <p>
                Психолог-тренер, консультант в сфере личностного развития и
                семейных отношений.
              </p>
              <p>
                Cертифицированный игропрактик и ведущая ряда игр,
                сертифицированный МАК-консультант, сертифицированный
                сказкотерапевт-практик, член Международного Союза
                сказкотерапевтов.
              </p>
              <p>Cпециалист проекта «Психология третьего тысячелетия».</p>
              <a
                className="secondary-content"
                href="https://vk.com/irina.v.ilina"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  id="mdi-vk"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0077FF"
                >
                  <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93V15.07C2 20.67 3.33 22 8.93 22H15.07C20.67 22 22 20.67 22 15.07V8.93C22 3.33 20.67 2 15.07 2M18.15 16.27H16.69C16.14 16.27 15.97 15.82 15 14.83C14.12 14 13.74 13.88 13.53 13.88C13.24 13.88 13.15 13.96 13.15 14.38V15.69C13.15 16.04 13.04 16.26 12.11 16.26C10.57 16.26 8.86 15.32 7.66 13.59C5.85 11.05 5.36 9.13 5.36 8.75C5.36 8.54 5.43 8.34 5.85 8.34H7.32C7.69 8.34 7.83 8.5 7.97 8.9C8.69 11 9.89 12.8 10.38 12.8C10.57 12.8 10.65 12.71 10.65 12.25V10.1C10.6 9.12 10.07 9.03 10.07 8.68C10.07 8.5 10.21 8.34 10.44 8.34H12.73C13.04 8.34 13.15 8.5 13.15 8.88V11.77C13.15 12.08 13.28 12.19 13.38 12.19C13.56 12.19 13.72 12.08 14.05 11.74C15.1 10.57 15.85 8.76 15.85 8.76C15.95 8.55 16.11 8.35 16.5 8.35H17.93C18.37 8.35 18.47 8.58 18.37 8.89C18.19 9.74 16.41 12.25 16.43 12.25C16.27 12.5 16.21 12.61 16.43 12.9C16.58 13.11 17.09 13.55 17.43 13.94C18.05 14.65 18.53 15.24 18.66 15.65C18.77 16.06 18.57 16.27 18.15 16.27Z" />
                </svg>
              </a>
            </CollectionItem>
          </Collection>
        </Col>
      </Row>
    </>
  );
};
